export default __webpack_public_path__ + "static/media/guolianrui.95b8ab70.jpg";